/**
 * Cabecalho de coluna clicavel com indicador de ordenacao — para tabelas
 * legadas custom (Marcenaria, Entregas, etc) que NAO usam PainelTabela.
 *
 * Renderiza o ResizableTh (para manter resize de colunas) + um icone
 * chevron que reflete o estado: neutro (nao ordenado), ascendente,
 * descendente. Clicar dispara onSort(columnKey).
 *
 * Uso:
 *   <SortableHeader columnKey="cliente" sort={sort} onSort={toggle}>
 *     Cliente
 *   </SortableHeader>
 *
 * `sort` vem do hook useOrdenacaoTabela ({ key, dir }).
 */

import React from "react";
import styled from "styled-components";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

import { ResizableTh } from "../ResizableColumns";

export default function SortableHeader({
  columnKey,
  sort,
  onSort,
  as,
  children,
  align,
  ...rest
}) {
  const ativo = sort?.key === columnKey;
  const dir = ativo ? sort.dir : null;

  return (
    <ResizableTh
      as={as}
      columnKey={columnKey}
      {...rest}
      onClick={() => onSort?.(columnKey)}
      style={{ cursor: "pointer", userSelect: "none", ...(rest.style || {}) }}
      title="Clique para ordenar"
    >
      <Inner $align={align}>
        <span>{children}</span>
        <IconeWrap $ativo={ativo} aria-hidden="true" data-export-no-print>
          {dir === "desc" ? <FiChevronDown size={13} /> : <FiChevronUp size={13} />}
        </IconeWrap>
      </Inner>
    </ResizableTh>
  );
}

const Inner = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  justify-content: ${({ $align }) =>
    $align === "right" ? "flex-end" : $align === "center" ? "center" : "flex-start"};
  width: 100%;
`;

const IconeWrap = styled.span`
  display: inline-flex;
  align-items: center;
  /* Quando nao esta ativo, o chevron fica esmaecido como dica de que
     a coluna eh ordenavel. Quando ativo, opacidade total + cor de
     destaque. */
  opacity: ${({ $ativo }) => ($ativo ? 1 : 0.32)};
  color: ${({ theme, $ativo }) => ($ativo ? theme.accent : "inherit")};
  transition: opacity 0.15s ease, color 0.15s ease;
`;
